import { createContext, useContext, useEffect, useState } from "react";
import translator from "@/lib/pageTranslator";

const TranslateCtx = createContext(null);

export function TranslateProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("ap_lang") || "en");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    translator.init();
    if (lang !== "en") {
      setBusy(true);
      // Delay a beat so the first route has rendered before translating.
      const t = setTimeout(() => { translator.setLanguage(lang).finally(() => setBusy(false)); }, 600);
      return () => clearTimeout(t);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const setLang = async (code) => {
    setLangState(code);
    localStorage.setItem("ap_lang", code);
    setBusy(true);
    try { await translator.setLanguage(code); } finally { setBusy(false); }
  };

  return <TranslateCtx.Provider value={{ lang, setLang, busy }}>{children}</TranslateCtx.Provider>;
}

export const useTranslate = () => useContext(TranslateCtx) || { lang: "en", setLang: () => {}, busy: false };
